import { render } from "./StudyManagment.vue?vue&type=template&id=1cc36651&scoped=true"
import script from "./StudyManagment.js?vue&type=script&lang=js"
export * from "./StudyManagment.js?vue&type=script&lang=js"

import "./StudyManagment.vue?vue&type=style&index=0&id=1cc36651&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc36651"]])

export default __exports__